import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

declare var instituicaoConstants;
/*
  Generated class for the EnderecoProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class EnderecoProvider {
  baseUrl = environment.API_URL;
  constructor(public http: HttpClient) {
    console.log('Hello EnderecoProvider Provider');
  }

  getPaises() {
    let idioma = 'pt';
    if (instituicaoConstants && instituicaoConstants.LINGUAGEM) idioma = instituicaoConstants.LINGUAGEM;
    return this.http
      .get<any>(this.baseUrl + '/endereco-externo/paises?idioma=' + idioma, {
        params: { fields: 'id,nome' },
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getEstados(idPais) {
    return this.http.get<any>(this.baseUrl + '/endereco-externo/dados-pais/' + idPais).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getCidades(idEstado) {
    return this.http
      .get<any>(this.baseUrl + '/endereco-externo/cidade-by-estado/' + idEstado, {
        params: { fields: 'id,nome' },
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getCEP(cep) {
    return this.http.get<any>(this.baseUrl + '/endereco-externo/cep/' + cep).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getAreaRegiao(idInstituicao) {
    return this.http
      .get<any>(this.baseUrl + '/endereco-externo/get-area-regiao', {
        params: { idInstituicao: idInstituicao },
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/endereco/endereco.ts